import React from "react";
import ModalButtons from "./modal-buttons";
var Isvg = require("../../../vendor/react-inlinesvg");

class ModalContainer extends React.Component {
  constructor(props) {
    super(props);

    this.modalRef = React.createRef();
    this.modalheaderRef = React.createRef();

    this._updateWindowValues = this._updateWindowValues.bind(this);
    this._updateModalLocation = this._updateModalLocation.bind(this);
    this._escapeKey = this._escapeKey.bind(this);
    this._removeModal = this._removeModal.bind(this);
    this._preventClose = this._preventClose.bind(this);
    this._redraw = this._redraw.bind(this);
    this._updateHeaderHeight = this._updateHeaderHeight.bind(this);
    this._changeTitle = this._changeTitle.bind(this);
    this._toggleCloseButton = this._toggleCloseButton.bind(this);
    this._toggleDropDown = this._toggleDropDown.bind(this);
    this._changeDescription = this._changeDescription.bind(this);
    this._changeSize = this._changeSize.bind(this);

    this.state = {
      intersitial: props.intersitial,
      title: props.title,
      description: props.description,
      width: props.width,
      height: props.height,
      focusedElementBeforeModal: document.activeElement,
      elementToFocusOnModal: null,
      modalHeaderHeight: 0,
      hideCloseButton: props.hideCloseButton,
      dropDownVisible: false,
      content: React.cloneElement(props.content, {
        changeModalTitle: this._changeTitle,
        changeModalDescription: this._changeDescription,
        changeModalSize: this._changeSize,
        toggleCloseButton: this._toggleCloseButton,
        toggleDropDown: this._toggleDropDown
      })
    };
  }

  componentDidMount() {
    this.mounted = true;

    $(window).on("keyup", this._escapeKey);
    Fraction.Helpers.forceModalUpdate = this._redraw;
    $(window).on("resize", this._updateModalLocation);
    if (this.props.elementToFocusOnModal) {
      $(this.props.elementToFocusOnModal).focus();
    } else if (!Fraction.TourQueue || Fraction.TourQueue.length === 0) {
      $("#modal-container")
        .find(":focusable")
        .first()
        .focus();
    }

    if (Fraction.Helpers.modalCloseRefocus.length > 0) {
      this.setState({ focusedElementBeforeModal: false });
    }

    Fraction.Helpers.runAfterRender(() => {
      this._updateHeaderHeight();
    });
  }

  componentWillUnmount() {
    $(window).unbind("keyup", this._escapeKey);
    $(window).unbind("resize", this._updateModalLocation);
    if (this.state.focusedElementBeforeModal) {
      Fraction.Helpers.runAfterRender(() => {
        this.state.focusedElementBeforeModal.focus();
      });
    }

    this.mounted = false;
  }

  _updateWindowValues() {
    if (this.mounted) {
      this._updateHeaderHeight();
    }
  }

  _updateModalLocation() {
    Fraction.Helpers.updateModalLocation();
    if (
      Fraction.Helpers.isSmallScreen() &&
      this.modalRef.current.clientWidth >= $(window).width() &&
      this.props.intersitial
    ) {
      this.setState({ intersitial: true });
    } else {
      this.setState({ intersitial: false });
    }
  }

  _topTrapKey() {
    $("#modal-container")
      .find(":focusable")
      .last()
      .focus();
  }

  _bottomTrapKey() {
    $("#modal-container")
      .find(":focusable")
      .first()
      .focus();
  }

  _escapeKey(e) {
    if (e.keyCode === 27) {
      this.props.modalCloseCallback();
      Fraction.Helpers.removeModal(e, $(".modal"));
    }
  }

  _removeModal(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!this.props.noOuterClick) {
      this.props.modalCloseCallback();
      Fraction.Helpers.removeModal(e);
    }
  }

  _preventClose(e) {
    e.stopPropagation();
  }

  // redraw this container!
  _redraw() {
    setTimeout(() => this.forceUpdate(), 0);
  }

  _touchMove(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  _updateHeaderHeight(modalHeaderHeight) {
    modalHeaderHeight = this.modalheaderRef.current.offsetHeight;
    if (modalHeaderHeight >= 95) {
      this.setState({ modalHeaderHeight: modalHeaderHeight + 10 });
    } else {
      this.setState({ modalHeaderHeight: false });
    }
  }

  _changeTitle(title) {
    this.setState({ title: title }, () => {
      this._updateModalLocation();
    });
  }

  _toggleCloseButton(hideCloseButton) {
    this.setState({ hideCloseButton });
  }

  _toggleDropDown(dropDownVisible) {
    this.setState({ dropDownVisible });
  }

  _changeDescription(description) {
    this.setState({ description: description }, () => {
      this._updateHeaderHeight();
      this._updateModalLocation();
    });
  }

  _changeSize(width, height) {
    var newWidth, newHeight;
    if (this.state.width != width) {
      if (this.state.width < width) {
        newWidth = Math.min(this.state.width + 10, width);
      } else {
        newWidth = Math.max(this.state.width - 10, width);
      }
      this.setState({ width: newWidth }, () => {
        this._updateModalLocation();
        setTimeout(() => {
          this._changeSize(width, height);
        }, 10);
      });
    } else if (this.state.height != height) {
      if (this.state.height < height) {
        newHeight = Math.min(this.state.height + 10, height);
      } else {
        newHeight = Math.max(this.state.height - 10, height);
      }
      this.setState({ height: newHeight }, () => {
        this._updateModalLocation();
        setTimeout(() => {
          this._changeSize(width, height);
        }, 10);
      });
    }
  }

  render() {
    var buttons = this.props.buttons || [];
    var modalStyles = {};
    if (this.props.position) {
      modalStyles.left = this.props.position.left;
      modalStyles.top = this.props.position.top;
    }
    if (!Fraction.Helpers.isSmallScreen()) {
      if (this.state.width) {
        modalStyles.width = this.state.width;
      }
      if (this.state.height) {
        modalStyles.height = this.state.height;
      }
    }

    return (
      <div>
        <div
          aria-hidden={true}
          onFocus={this._topTrapKey}
          className="traptabkey"
          tabIndex={0}
        />
        <div
          ref={this.modalRef}
          id="modal-container"
          className={
            "modal " +
            this.props.definingClass +
            (this.props.fullscreen ? " fullscreen" : "") +
            " " +
            this.props.padding +
            (this.state.dropDownVisible ? " dropDownVisible" : " ") +
            (this.props.position ? " ignore-position" : " ")
          }
          onClick={this._preventClose}
          aria-labelledby="modal-title"
          style={modalStyles}
        >
          <div
            className={
              "modal-box" + (this.state.intersitial ? " intersitial" : "")
            }
          >
            <div
              id="modal-header"
              className={
                this.state.modalContainerHeader ? "modalContainerHeader" : ""
              }
              ref={this.modalheaderRef}
            >
              {!this.state.hideCloseButton && (
                <button
                  className="modal-x noButton"
                  onClick={this._removeModal}
                  onTouchEnd={this._removeModal}
                >
                  <Isvg src="/img/x_gray.svg" />
                  <span className="offScreen">{i18n.t("base.close")}</span>
                </button>
              )}
              {this.state.title && (
                <h2
                  id="modal-title"
                  className={
                    "modal-title" +
                    (this.props.fullscreen ? " fullscreen" : "") +
                    (this.state.description ? " with-description" : "")
                  }
                  tabIndex={-1}
                >
                  {this.state.title}
                </h2>
              )}
              {this.state.description &&
                !this.props.definingClass === "sharing" && (
                  <p
                    className={
                      "modal-description" +
                      (this.props.fullscreen ? " fullscreen" : "")
                    }
                  >
                    {this.state.description}
                  </p>
                )}
            </div>
            <div
              id="modal-content-container"
              style={{ top: this.state.modalHeaderHeight }}
              className={
                "modal-content" +
                (buttons.length > 0 || this.props.delegateButtons
                  ? " with-buttons"
                  : "") +
                (this.props.fullscreen ? " fullscreen" : "") +
                (this.state.title ? "" : " no-title") +
                (this.state.description ? " with-description" : "") +
                (this.props.className ? " " + this.props.className : "")
              }
            >
              {this.state.content}
            </div>
            <ModalButtons
              buttons={buttons}
              modalCloseCallback={this.props.modalCloseCallback}
            />
          </div>
        </div>
        <div
          onClick={this._removeModal}
          aria-hidden={true}
          className="modalOverlay"
          tabIndex="-1"
        />
        <div
          aria-hidden={true}
          onFocus={this._bottomTrapKey}
          className="traptabkey"
          tabIndex={0}
        />
      </div>
    );
  }
}

const ModalMixin = {
  // Show the given modal
  _showModal: function(modalObject, refocusDOM, parentElement) {
    // TODO there's a chance this is never used.. at all...
    this.setState({ modalToShow: modalObject, modalElement: parentElement });
    Fraction.Helpers.modalCloseRefocus =
      Fraction.Helpers.modalCloseRefocus || [];
    if (refocusDOM) {
      Fraction.Helpers.modalCloseRefocus.push(refocusDOM);
    }
    Fraction.Helpers.runAfterRender(() => {
      Fraction.Helpers.updateModalLocation();
    });
  },

  // Remove the modal from the reading view
  _removeModal: function() {
    this.setState({ modalToShow: null });
    if (
      Fraction.Helpers.modalCloseRefocus &&
      Fraction.Helpers.modalCloseRefocus.length > 0
    ) {
      Fraction.Helpers.modalCloseRefocus.pop().focus();
    }
  }
};

export { ModalContainer, ModalMixin };
